import { useLocation } from "react-router-dom";
import LiveGames from "../components/liveGames/liveGames";

export default function LiveGamesPage() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);

  const league = params.get("league");
  const section = params.get("section");
  const filter = params.get("filter");
  const version= params.get("country");

  return(
    <LiveGames seccion={section} ligaFut={league} showFilter={filter} version={version}/>
  )

}